<template>
  <a-collapse
      v-model:activeKey="activeKeys"
      class="management-potential-instruction"
      expand-icon-position="end"
      :bordered="false"
  >
    <template #expandIcon="{ isActive }">
      <UpOutlined v-if="isActive" />
      <DownOutlined v-else />
    </template>

    <a-collapse-panel
        key="1"
        header="Подробнее о профилях Управленческого потенциала"
        class="management-potential-instruction__panel"
    >
      <div class="management-potential-instruction__content">
        <p>
          Максимально высокий управленческий потенциал наблюдается при сбалансированном ЭИ-профиле
          в пределах высшего диапазона баллов:
        </p>

        <ul class="management-potential-instruction__list">
          <li class="management-potential-instruction__list-item">
            <span class="management-potential-instruction__bold">Гибкость:</span>
            устойчивость к неопределенности и фокус на результате.
          </li>

          <li class="management-potential-instruction__list-item">
            <span class="management-potential-instruction__bold">Переговоры:</span>
            конструктивное решение конфликтов и развитие команды.
          </li>

          <li class="management-potential-instruction__list-item">
            <span class="management-potential-instruction__bold">Многозадачность:</span>
            использование эмоций как драйвера продуктивности.
          </li>

          <li class="management-potential-instruction__list-item">
            <span class="management-potential-instruction__bold">Лидерство:</span>
            сохранение энергии под давлением и мотивация команды на достижения.
          </li>
        </ul>

        <p>
          <span class="management-potential-instruction__bold">Сбалансированный профиль</span>
          повышает управленческий потенциал: сбалансированные показатели в пределах одного диапазона
          обеспечивают гибкость поведения и широкую вариативность способов взаимодействия с окружением.
        </p>

        <p>
          <span class="management-potential-instruction__bold">Разбалансированный профиль</span>
          снижает управленческий потенциал: большой разрыв между показателями указывает на отсутствие
          гибкости. Это ведёт к выбору жёстких стратегий, которые не учитывают потребности команды
          и меняющиеся обстоятельства.
        </p>

        <div class="management-potential-instruction__table-scroll">
          <table class="management-potential-instruction__table">
            <thead>
            <tr>
              <th>Тип профиля</th>
              <th>Разброс баллов</th>
            </tr>
            </thead>

            <tbody>
            <tr
                v-for="row in rows"
                :key="row.type"
            >
              <td>
                <span class="management-potential-instruction__bold">
                  {{ row.type }}
                </span>
              </td>

              <td>{{ row.scoreSpread }}</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </a-collapse-panel>
  </a-collapse>
</template>

<script>
import { ref } from 'vue'
import {
  UpOutlined,
  DownOutlined,
} from '@ant-design/icons-vue'

export default {
  name: 'ManagementPotentialInstruction',

  components: {
    UpOutlined,
    DownOutlined,
  },

  setup() {
    const activeKeys = ref(['1'])

    const rows = [
      {
        type: 'Сбалансированный',
        scoreSpread: '10–20',
        managementPotential: 'Высший',
        eiSectionsLocation: 'В одном / соседних диапазонах',
      },
      {
        type: 'Относительно сбалансированный',
        scoreSpread: '20–30',
        managementPotential: 'Высокий',
        eiSectionsLocation: 'В одном / соседних диапазонах',
      },
      {
        type: 'Несбалансированный',
        scoreSpread: '30–40',
        managementPotential: 'Умеренный / С рисками',
        eiSectionsLocation: 'В соседних двух / трех диапазонах',
      },
      {
        type: 'Разбалансированный',
        scoreSpread: 'от 40 и выше',
        managementPotential: 'Низкий',
        eiSectionsLocation: '-',
      },
    ]

    return {
      activeKeys,
      rows,
    }
  },
}
</script>

<style scoped>
.management-potential-instruction {
  width: 100%;
  margin-top: 12px;
  background: #fafafa;
  border-radius: 8px;
  font-family: "Open Sans", sans-serif;
}

.management-potential-instruction :deep(.ant-collapse-item) {
  border-bottom: 0;
}

.management-potential-instruction :deep(.ant-collapse-header) {
  align-items: center;
  padding: 16px;
  color: #262626;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.4;
}

.management-potential-instruction :deep(.ant-collapse-expand-icon) {
  color: #262626;
  font-size: 13px;
}

.management-potential-instruction :deep(.ant-collapse-content) {
  border-top: 0;
  background: transparent;
}

.management-potential-instruction :deep(.ant-collapse-content-box) {
  padding: 0 16px 16px;
}

.management-potential-instruction__content {
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.88);
}

.management-potential-instruction__content p {
  margin: 0 0 8px;
}

.management-potential-instruction__list {
  margin: 0 0 10px;
  padding: 0 0 0 8px;
  list-style: none;
}

.management-potential-instruction__list-item {
  position: relative;
  margin: 0 0 4px;
  padding-left: 16px;
  line-height: 120%;
}

.management-potential-instruction__list-item::before {
  content: "";
  position: absolute;
  top: 0.48em;
  left: 0;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.88);
  transform: translateY(-50%);
}

.management-potential-instruction__bold {
  font-weight: 600;
}

.management-potential-instruction__table-scroll {
  width: 100%;
  margin-top: 24px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.management-potential-instruction__table {
  width: 100%;
  min-width: 500px;
  max-width: 500px;
  border-collapse: collapse;
  table-layout: fixed;

  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 120%;
}

.management-potential-instruction__table th,
.management-potential-instruction__table td {
  font-family: "Open Sans", sans-serif;
  padding: 8px 0;
  border-bottom: 1px solid #ececec;
  font-weight: 400;
  line-height: 1.3;
  text-align: left;
  vertical-align: top;
}

.management-potential-instruction__table th {
  color: #9b9b9b;
  font-weight: 400;
}

.management-potential-instruction__table th:nth-child(1),
.management-potential-instruction__table td:nth-child(1) {
  width: 28%;
  padding-right: 16px;
}

.management-potential-instruction__table th:nth-child(2),
.management-potential-instruction__table td:nth-child(2) {
  width: 14%;
  padding-right: 16px;
}

.management-potential-instruction__table th:nth-child(3),
.management-potential-instruction__table td:nth-child(3) {
  width: 22%;
  padding-right: 16px;
}

.management-potential-instruction__table th:nth-child(4),
.management-potential-instruction__table td:nth-child(4) {
  width: 36%;
}

.management-potential-instruction__table tbody tr:last-child td {
  border-bottom: 0;
}

:deep(.ant-collapse-header-text) {
  font-weight: 600;
  font-size: 14px;
  line-height: 120%;
  color: rgba(0, 0, 0, 0.85);
}
</style>